import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if(environment['sentryDsn']) {
  Sentry.init({
    dsn: environment['sentryDsn'],
    tracePropagationTargets: ['localhost', /^\//]
  })
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
